export type SearchMapType = {[key: string]: string};

/**
 * Get parameter map for router search
 * @param {string} search - search value for the route
 * @returns {SearchMapType} map for router search
 */
export const getSearchMap = (search: string): SearchMapType =>
    search
        .slice(1)
        .split('&')
        .reduce((acc, item) => {
            const param = item.split('=');
            if (param.length < 2) return acc;
            return {...acc, [param[0]]: param[1]};
        }, {});
